<template>
  <div
    class="behaviour-manage-stat-card rounded-3 bg-white p-3 h-100"
    :data-testid="testId"
  >
    <div class="d-flex align-items-center gap-2 mb-2">
      <i
        :class="iconClass"
        class="behaviour-manage-stat-card__icon"
        aria-hidden="true"
      />
      <span class="behaviour-manage-stat-card__label text-muted small mb-0">
        {{ label }}
      </span>
      <button
        v-if="showInfo"
        type="button"
        class="btn btn-link p-0 behaviour-manage-stat-card__info-btn"
        :aria-label="infoAriaLabel"
        data-testid="behaviour-manage-stat-info"
      >
        <i class="ri-information-line" aria-hidden="true" />
      </button>
    </div>
    <p class="behaviour-manage-stat-card__value mb-0">{{ value }}</p>
  </div>
</template>

<script>
export default {
  name: "BehaviourManageStatCard",
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    iconClass: {
      type: String,
      default: "ri-medal-line"
    },
    showInfo: {
      type: Boolean,
      default: false
    },
    infoAriaLabel: {
      type: String,
      default: "More information"
    },
    testId: {
      type: String,
      default: "behaviour-manage-stat-card"
    }
  }
}
</script>
